import * as React from "react";
import { useEffect } from "react";
import ErrorsActions from "actions/errors/ErrorsActions";
import ErrorBoundary from "components/errors/ErrorBoundary";
import { createReactError } from "logic/errors/ReportedErrors";
const ErrorComponent = ({ error }) => {
  useEffect(() => {
    console.error(error);
    ErrorsActions.report(createReactError(error, { componentStack: error.stack }));
  }, [error]);
  return null;
};
const emptyPlaceholder = /* @__PURE__ */ React.createElement(React.Fragment, null);
const loadAsync = (factory) => {
  const Component = React.lazy(factory);
  return React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(ErrorBoundary, { FallbackComponent: ErrorComponent }, /* @__PURE__ */ React.createElement(React.Suspense, { fallback: emptyPlaceholder }, /* @__PURE__ */ React.createElement(Component, { ...props, ref }))));
};
export default loadAsync;
